import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import FeatureName from "../../visComponents/featureName";
import {getFeatureUnit, toFixedPrice} from "../../../misc/helpers";
import MaterialsWizardFooterStepThumbnail from "../../qkbPages/materialsWizard/materialsWizardFooterStepThumbnail";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import {getWizardGroupName} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";

const WizardConflictPopupCartItem = (props) => {

  const {cartItem, intl, fabricatorData, wizardSelectedValues, wizardActiveItem} = props;

  let featureGroup = null;
  if (cartItem.cartFeature.getParent) {
    featureGroup = cartItem.cartFeature.getParent();
  }
  const wizardSelectedKey = Object.keys(wizardSelectedValues).find(wizKey => {
    return wizardSelectedValues[wizKey].wizardGroup && (wizardSelectedValues[wizKey].wizardGroup.id === cartItem.fromWizardGroupId)
  });
  const wizardSelectedValue = wizardSelectedKey ? wizardSelectedValues[wizardSelectedKey] : null;
  const wizardGroup = wizardActiveItem.wizardGroups.find(wizGroup => {
    return wizGroup.id === cartItem.fromWizardGroupId
  });
  const wizardGroupName = getWizardGroupName(wizardGroup);
  // console.log("wizardSelectedValue", wizardSelectedValue);

  const unit = getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, cartItem.quantity, cartItem);

  return (
    <li className="apply-popup-item" key={cartItem.id}>
      <div className="table">
        <div className="apply-popup-item__image apply-popup-item__image--small">
          {wizardSelectedValue || featureGroup ? (
            <MaterialsWizardFooterStepThumbnail wizardGroup={wizardGroup}
                                                featureGroup={featureGroup}
                                                wizardSelectedValue={wizardSelectedValue}/>
          ) : null}
        </div>
        <div className="apply-popup-item__main">
          <p className="apply-popup-item__main-title bold">
            {wizardGroupName ? wizardGroupName + " - " : null}<FeatureName feature={cartItem.cartFeature}/>
          </p>
          {cartItem.partId === "room" ? null : (
            <p className="apply-popup-item__main-description">
              {unit}: {toFixedPrice(parseFloat(cartItem.displayFakeQuantity) === cartItem.displayFakeQuantity
              ? cartItem.displayFakeQuantity
              : cartItem.quantity)}
            </p>
          )}
        </div>
      </div>
    </li>
  )
}

WizardConflictPopupCartItem.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired
}

const mapStateToProps = (store, ownProps) => {
  const {wizardSelectedValues, wizardList, wizardActiveItem} = store.wizardState;
  const fabricatorData = store.fabricatorState;

  return {
    wizardList,
    fabricatorData,
    wizardSelectedValues,
    wizardActiveItem: ownProps.wizardActiveItem || wizardActiveItem,
  };
};

export default injectIntl(
  connect(mapStateToProps)(WizardConflictPopupCartItem)
)
